import { PROJECTILE, WORLD } from "../constants";
import type { Projectile } from "../engine/types";

let nextId = 100000;

export function createProjectile(originX: number, originY: number): Projectile {
  return {
    id: nextId++,
    x: originX,
    y: originY,
    w: PROJECTILE.SIZE,
    h: PROJECTILE.SIZE,
    vx: PROJECTILE.SPEED,
    vy: 0,
    alive: true,
    travelled: 0,
  };
}

export function updateProjectile(p: Projectile, dtSec: number): void {
  const dx = p.vx * dtSec;
  p.x += dx;
  p.travelled += Math.abs(dx);
  if (p.x > WORLD.WIDTH + 40 || p.travelled > PROJECTILE.MAX_RANGE_PX) {
    p.alive = false;
  }
}
